module.exports = __webpack_public_path__ + "static/media/icone-dica-legal.9ad9f96c.svg";